import { DataVersion } from '@hakimo-ui/hakimo/types';
import { ResourceType } from '@hakimo-ui/hakimo/data-access';
import { range, setDataVersionParam } from '@hakimo-ui/hakimo/util';
import dayjs from 'dayjs';

export function getSharedResourcePath(
  resourceType: ResourceType,
  accessToken: string,
  timestamp?: string,
  dataVersion?: DataVersion
) {
  let resourceName = '';
  switch (resourceType) {
    case 'alarm':
    case 'scan-raw-alarm':
      resourceName = 'alarm';
      break;
    case 'location-alarm':
      resourceName = 'location-alarm';
      break;
    case 'live-view':
      resourceName = 'live-view';
      break;
    case 'alarm-group':
      resourceName = 'alarm_group';
      break;
  }

  const params = new URLSearchParams();
  params.append('sharedToken', accessToken);

  if (
    timestamp &&
    resourceType !== 'alarm-group' &&
    resourceType !== 'scan-raw-alarm'
  ) {
    const date = dayjs(timestamp).utc();
    params.append('partitionKey', date.format('YYYYMM'));
  }

  if (resourceType === 'scan-raw-alarm') {
    params.append('product', 'scan');
  }

  // Carry the alarm's data version so the shared route (which has no v2/v3
  // toggle of its own) reads the same dataset. Only v3 opts in; v2 is the
  // legacy default, so a v2 link stays byte-identical (no param).
  setDataVersionParam(params, dataVersion);

  return `/shared/${resourceName}?${params.toString()}`;
}

export type DurationUnit = 'hour' | 'day' | 'week';

export interface DurationOption {
  unit: DurationUnit;
  allowedValues: number[];
}

const liveViewOptions: DurationOption[] = [
  {
    unit: 'hour',
    allowedValues: range(1, 12),
  },
];

const allOptions: DurationOption[] = [
  {
    unit: 'hour',
    allowedValues: range(1, 23),
  },
  {
    unit: 'day',
    allowedValues: range(1, 6),
  },
  {
    unit: 'week',
    allowedValues: range(1, 6),
  },
];

export function getDurationOptions(resourceType: ResourceType) {
  if (resourceType === 'live-view') {
    return liveViewOptions;
  } else {
    return allOptions;
  }
}
